import {
  CondenserType,
  ConfigurationType,
  UpdatableConfigItem,
  ZoneType
} from 'data/types';

export function applyItemUpdates<T extends { uniqueId: string }>(
  target: T,
  item: UpdatableConfigItem,
  keys: string[]
): void {
  if (target.uniqueId === item.uniqueId) {
    keys.forEach((key) => {
      // eslint-disable-next-line no-param-reassign
      target[key] = item[key];
    });
  }
}

export function updateConfigurationHierarchy(
  config: ConfigurationType,
  item: UpdatableConfigItem,
  keys: string[]
): void {
  applyItemUpdates(config, item, keys);
  config.condensers.forEach((condenser) => {
    applyItemUpdates(condenser, item, keys);
    condenser.zones.forEach((zone) => {
      applyItemUpdates(zone, item, keys);
      zone.zoneItems.forEach((zoneItem) => {
        applyItemUpdates(zoneItem, item, keys);
      });
    });
  });
}

export function deleteFromZoneItems(zone: ZoneType, uniqueId: string): boolean {
  const itemIndex = zone.zoneItems.findIndex(
    (item) => item.uniqueId === uniqueId
  );
  if (itemIndex !== -1) {
    zone.zoneItems.splice(itemIndex, 1);
    return true;
  }
  return false;
}

export function deleteFromZones(
  condenser: CondenserType,
  uniqueId: string
): boolean {
  const zoneIndex = condenser.zones.findIndex(
    (zone) => zone.uniqueId === uniqueId
  );
  if (zoneIndex !== -1) {
    condenser.zones.splice(zoneIndex, 1);
    return true;
  }
  return condenser.zones.some((zone) => deleteFromZoneItems(zone, uniqueId));
}

export function deleteFromCondensers(
  config: ConfigurationType,
  uniqueId: string
): boolean {
  const condenserIndex = config.condensers.findIndex(
    (c) => c.uniqueId === uniqueId
  );
  if (condenserIndex !== -1) {
    config.condensers.splice(condenserIndex, 1);
    return true;
  }
  return config.condensers.some((condenser) =>
    deleteFromZones(condenser, uniqueId)
  );
}
